import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { LoginService } from 'src/app/services/LoginService/login-service.service';
import { SessionService } from 'src/app/services/StoreService/SessionService/session.service';
import { LogoutService } from 'src/app/services/LogoutService/logout-service.service';

@Component({
  selector: 'app-log-in',
  templateUrl: './log-in.component.html',
  styleUrls: ['./log-in.component.scss']
})

export class LogInComponent {

  constructor(
    private router: Router,
    private loginService: LoginService,
    private sessionService: SessionService,
    private logoutService: LogoutService
  ) { }

  ngOnInit() {
    this.checkToken();
    document.getElementById("email").focus();
  }

  failLogin = false;
  sessionStarted = false;
  errorLogin = false;

  loginForm: FormGroup = new FormGroup({
    email: new FormControl("", [Validators.required]),
    password: new FormControl("", [Validators.required])
  });

  hide = true;

  loader = false;

  save(event: Event) {
    event.preventDefault();
    if (this.loginForm.valid) {
      this.onLogin();
    } else {
      this.loginForm.markAllAsTouched();
    }
  }

  get email() {
    return this.loginForm.get("email");
  }

  get password() {
    return this.loginForm.get("password");
  }

  checkToken() {

    const user = this.sessionService.getUser() || null;

    if (user || localStorage.getItem("token")) {
      this.router.navigate(["/pv/request-day"]);
    }
  }

  onLogin() {
    localStorage.removeItem("token");
    this.loader = true;
    this.errorLogin = false;
    this.failLogin = false;
    if (!localStorage.getItem("token")) {
      this.loginService.singIn(this.loginForm.get("email").value, this.loginForm.get("password").value)
        .subscribe((user: any) => {
          if (user != null) {
            this.sessionService.newUser(user);
            localStorage.setItem("token", user.token.token);
            this.router.navigate(["/pv/request-day"]);
          }
        }, error => {
          if (error.error.result == "FAIL") {
            this.failLogin = true;
            this.loader = false;
          } else {
            this.errorLogin = true;
            this.loader = false;
          }
        })
    } else {
      this.sessionStarted = true;
      this.loader = false;
    }
  }

  hidePassword() {
    this.hide = !this.hide;
  }

}
